import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useHubPetParent } from '../HubPetParentContext';
import { PetParentAnimal } from '../../../types/PetParent';
import { getPrimaryAnimal } from '../Home/utils';
import { hashids } from '../../../utilities';

/**
 * Picks the primary pet's species and redirects to its species-specific
 * Welcome Home album. Used by the Albums nav item — the test rollout only
 * surfaces a single album per pet parent.
 */
function AlbumsRedirect() {
  const { petParent, loading } = useHubPetParent();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  const primary: PetParentAnimal | undefined = getPrimaryAnimal(petParent)
    || (petParent?.animals?.[0] as PetParentAnimal | undefined);

  if (!primary) {
    // No pet on the account — fall back to home.
    return <Navigate to="/hub/home" replace />;
  }

  const species = primary.animalType?.toLowerCase() === 'cat' ? 'cat' : 'dog';
  return <Navigate to={`/hub/albums/${hashids.encode(primary.id)}/welcome-home-${species}`} replace />;
}

export default AlbumsRedirect;
